import request from '../utils/request';

//订单列表
export function orderList(data) {
    return request({
        url: '/home/order/list',
        method: 'post',
        data: data,
    });
}
//订单删除
export function delOrder(data) {
    return request({
        url: 'home/order/del',
        method: 'post',
        data: data,
    });
}
//需求删除
export function delBook(data) {
    return request({
        url: 'home/book/del',
        method: 'post',
        data: data,
    });
}
